import * as React from 'react';
import { EntityConfig, entityStandardFormFields } from '@shapeable/core';
import { EcologicalPrinciple as MyType } from '@shapeable/kelp-forest-alliance-types';
const gql = String.raw;

export const EcologicalPrinciple: EntityConfig<MyType> = {
  name: 'EcologicalPrinciple',
  label: 'SER Ecological Restoration Principle',
  type: 'taxonomy',
  icon: ({ icons }) => icons.Entities.Target,
  autoRoutes: ['list', 'create', 'update'],
  form: {
    fields: {
      ...entityStandardFormFields,
      title: { type: 'text' },
      number: { type: 'text' },
      description: { type: 'longText' },
    }
  }
};